import validate from "../util/formValidationMethods";

export function validateInput(inputVal, statePropertyKey) {
  switch (statePropertyKey) {
    case "contactName":
      return validate.name(inputVal);
    case "email":
      return validate.email(inputVal);
    case "eventName":
      return validate.hasText(inputVal);
    case "description":
      return validate.hasText(inputVal);
    case "locationAddress":
      return validate.hasText(inputVal);
    case "locationCity":
      return validate.hasText(inputVal);
    case "locationName":
      return validate.hasText(inputVal);
    case "locationState":
      return validate.hasText(inputVal);
    case "locationZip":
      return validate.hasText(inputVal);
    case "organization":
      return validate.hasText(inputVal);
    case "phone":
      return validate.hasText(inputVal);
    case "type":
      return validate.hasText(inputVal);
    case "termsAgreed":
      return inputVal === true;
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/Spirit/validateInput.js